import { render, staticRenderFns } from "./relatorioProposta.vue?vue&type=template&id=1d650090"
import script from "./relatorioProposta.vue?vue&type=script&lang=js"
export * from "./relatorioProposta.vue?vue&type=script&lang=js"
import style0 from "./relatorioProposta.vue?vue&type=style&index=0&id=1d650090&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports